import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../../base/base-mutation';
import { Rule } from '../../base/mutation-rules';
import { DataType } from '../../../data';
import { tableMergedRanges } from '../../../utils/table-utils';
import type { PresentationDataModel } from '../../../model/presentation-data-model';
import type { MaybeError } from '../../base/base-mutation';
import type {
    IValidInsertTableRowMutationData,
    IValidDeleteTableRowMutationData,
} from '../../base/valid-mutation-data';

export class InsertTableRowMutation extends BaseMutation<PresentationDataModel, IValidInsertTableRowMutationData> {
    public readonly type: MutationType = MutationType.InsertTableRow;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.shapeId || this.data.count === 0) return;

        const { shapeId, index, count } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        assert(table, 'shape should exist');
        if (!table) return;
        table.store.insertTableRow(index, count);
    }

    public invert(): [IValidDeleteTableRowMutationData] {
        const { pageId, shapeId, index, count } = this.data;
        return [
            {
                type: MutationType.DeleteTableRow,
                pageId,
                shapeId,
                index,
                count,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, index, count } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        const mergedRanges = tableMergedRanges(table?.store.tableData ?? {});
        return Rule.every(
            Rule.shape.should.existInPage(presentation, shapeId, pageId),
            Rule.table.can.addRowOrCol(presentation, shapeId, index, count, true, mergedRanges),
        );
    }
}
